import React, { FC } from "react";
import { ExpandMore } from "@material-ui/icons";
import { Select, SelectProps, makeStyles } from "@material-ui/core";
import { TheCycleverseTheme } from "src/theme";

const useInputStyles = makeStyles((theme: TheCycleverseTheme) => ({
  focused: {
    backgroundColor: theme.palette.common.white,
  },
}));

const useStyles = makeStyles((theme: TheCycleverseTheme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: 4,
    fontWeight: 900,
    paddingLeft: 8,
    "&:focus": {
      backgroundColor: theme.palette.common.white,
      borderRadius: 4,
      fontWeight: 900,
      paddingLeft: 8,
    },
  },
}));

const CycleverseSelect: FC<SelectProps> = ({ children, ...props }) => {
  const classes = useStyles();
  const inputClasses = useInputStyles();
  return (
    <Select disableUnderline IconComponent={ExpandMore} classes={classes} {...props}>
      {children}
    </Select>
  );
};

export default CycleverseSelect;
